@import 'styles/mixins';
@import 'styles/variables';

/** Following rule was disabled in order to facilitate introduction of eslint to the codebase (in other words, I didn't
want to bother fixing it) and not on purpose. If you know anything about this code, please fix */
/* stylelint-disable css-modules/no-global-scoped-selector */
:global html {
  -webkit-print-color-adjust: exact;
  overflow: scroll;
}

:global body {
  overflow-y: auto;
  height: unset;
}

:global .blaze-toast-container {
  display: none;
}
/* stylelint-enable css-modules/no-global-scoped-selector */

.root {
  background: var(--neutral-0);
}

.previewPngExportContainer {
  padding: 24px;
  min-height: 100vh;
}

.htmlExportContainer {
  padding: 96px;
  max-width: calc(700px + 2 * 96px);
  margin: 0 auto;
}
